const searchNamespace = '/search';

const searchViewRelative = '/search_view';

const searchViewRoute = `${searchNamespace}${searchViewRelative}`;

export const searchNamespaces = {
    searchNamespace,
};

export const searchRelativeRoutes = {
    searchViewRelative,
};

export const searchAbsoluteRoutes = {
    searchViewRoute,
};
